import { useCallback } from 'react';
import { EmptyCell, GenericValueFormatterFunc } from './genericFormatters';
import { useGetVehicleGroupsQuery } from '@customer/store/apis/metadataApi';

export function useAssetGroupIdFormatter(): GenericValueFormatterFunc<number[]> {
  const { data: assetGroups } = useGetVehicleGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const formatter: GenericValueFormatterFunc<number[]> = useCallback(
    ({ value }) => {
      if (assetGroups && value && Array.isArray(value)) {
        const assetGroupNames: string[] = [];

        value.forEach(id => {
          if (typeof id === 'number') {
            const match = assetGroups.find(g => g.id === id);
            if (match && match.n) {
              assetGroupNames.push(match.n);
            }
          }
        });

        if (assetGroupNames.length) {
          // Enforce alphabetical order.
          const sorted = assetGroupNames.sort((a, b) => a.localeCompare(b));
          return sorted.join(', ');
        }
      }

      return EmptyCell;
    },
    [assetGroups],
  );

  return formatter;
}
